<template>
  <div class="body">
    <headerComponent :callback="headerCallbackHandler" />
    <main>
      <div class="wrapper-catalogue">
        <div class="menu-column">
          <router-link
            to="/catalogue/ceo_manager"
            tag="div"
            class="menu-item"
            active-class="selected"
            v-if="$store.getters.adminValue > 4"
            ><p>{{ td("views.catalog.catalog.ceo") }}</p></router-link
          >
          <router-link
            to="/catalogue/group_manager"
            tag="div"
            class="menu-item"
            active-class="selected"
            v-if="$store.getters.adminValue > 2"
            ><p>{{ td("views.catalog.catalog.resp") }}</p></router-link
          >
          <router-link
            to="/catalogue/team_manager"
            tag="div"
            class="menu-item"
            active-class="selected"
            ><p>{{ td("views.catalog.catalog.team") }}</p></router-link
          >
        </div>
        <router-view />

        <transition name="fade">
          <div class="container-alert" v-if="show_alert_box === true">
            <alertBox
              :msg="msg_alert"
              :callback="alertCallback"
              :delay="3000"
            />
          </div>
        </transition>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import headerComponent from "./../../components/header/headerComponent";
import { td } from "../../traductions/traductionsHelpers";

export default {
  name: "Catalogue",
  components: {
    headerComponent
  },
  data: () => {
    return {
      td,
      show_alert_box: false,
      admin_levels: {},
      user: {},
      admin_level: "",
      circle: {}
    };
  },
  methods: {
    headerCallbackHandler(obj) {
      obj;

      /*if (obj.type == "click-profil") {
        this.$router.push({ path: "/edit-profil" });
      }*/
    }
  },
  mounted() {
    this.user = this.$store.state.userData;
    this.admin_level = this.user.admin_level;
    this.admin_levels = this.$store.state.admin_levels;
    this.circle = this.$store.state.circleData;
  }
};
</script>
